<template>
  <!-- Comments-->
  <section aria-labelledby="notes-title" ref="comments-section">
    <div class="bg-white rounded-lg border shadow sm:overflow-hidden">
      <div class="divide-y divide-gray-200">
        <div class="px-4 py-5 sm:px-6">
          <h2 id="notes-title" class="text-lg font-medium text-gray-900">Comments</h2>
        </div>
        <div class="px-4 py-6 sm:px-6">
          <ul role="list" class="space-y-6">
            <li v-for="companyPost in posts" :key="'post-' + companyPost.uuid"
                :ref="'post-' + companyPost.uuid" :id="'post-' + companyPost.uuid">
              <div class="flex space-x-3">
                <div class="flex-shrink-0">
                    <span class="inline-block overflow-hidden w-10 h-10 rounded-full shadow"
                          :style="'background-color: ' + stringToColour(companyPost.post.author.name)">
                      <svg class="w-full h-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                      </svg>
                    </span>
                </div>
                <div class="flex-grow">
                  <div class="px-3 py-2 w-auto text-sm bg-past-blue rounded-xl">
                    <div class="text-gray-700">
                      <span class="font-semibold text-secondary">{{ companyPost.post.author.uuid === memberProfile.uuid ? 'Me' : companyPost.post.author.name }}</span>
                      {{ ' ' }}
                      <span class="text-black">&middot;</span>
                      {{ ' ' }}
                      <span class="text-xs">{{ postedAt(companyPost.createdAt) }}</span>
                    </div>
                    <div class="py-1.5 text-black text-justify">
                      <p v-html="companyPost.post.message"></p>
                    </div>
                    <div
                        v-if="!displayDefaultPost"
                        class="flex items-center mt-2 space-x-2 text-xs">
                      <span v-if="companyPost.post.likes > 0"
                            class="inline-flex items-center space-x-0.5 px-1.5 py-0.5 mb-1 rounded text-xs bg-secondary text-secondary-500-c opacity-70">
                        <ThumbUpIcon class="w-4 h-4"></ThumbUpIcon>
                        <!--                        <span class="text-xs">{{ Math.floor(Math.random() * (15 - 1)) + 1 }}</span>-->
                        <span class="text-xs">{{ companyPost.post.likes }}</span>
                      </span>
                      <button
                          v-if="companyPost.post.author.uuid !== memberProfile.uuid"
                          @click="likeComment($event, companyPost.post)"
                          type="button"
                          class="border-b-2 border-transparent hover:border-gray-400 hover:text-gray-900">
                        <span class="font-bold text-gray-600">Like</span>
                      </button>
                      {{ ' ' }}
                      <span v-if="companyPost.post.author.uuid !== memberProfile.uuid" class="text-black">&middot;</span>
                      {{ ' ' }}
                      <button
                          @click="replyTo($event, companyPost.post)"
                          type="button"
                          class="border-b-2 border-transparent hover:border-gray-400 hover:text-gray-900">
                        <!--                      <ReplyIcon class="w-4 h-4"></ReplyIcon>-->
                        <span class=" font-bold text-gray-600 capitalize">Reply</span>
                      </button>
                    </div>
                  </div>

                </div>
              </div>


              <div class="pt-6 pr-0 pb-4 pl-4 sm:pl-14"
                   v-if="companyPost.post.replies !== undefined && companyPost.post.replies.length > 0">
                <ul role="list" class="space-y-6">
                  <li v-for="reply in companyPost.post.replies" :key="'post-' + reply.referrerObjectIdentifier"
                      :ref="'post-' + reply.referrerObjectIdentifier" :id="'post-' + reply.referrerObjectIdentifier">
                    <div class="flex space-x-3">
                      <div class="flex-shrink-0">
                    <span class="inline-block overflow-hidden w-10 h-10 rounded-full shadow"
                          :style="'background-color: ' + stringToColour(reply.author.name)">
                      <svg class="w-full h-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                      </svg>
                    </span>
                      </div>
                      <div class="flex-grow">
                        <div class="px-3 py-2 w-auto text-sm bg-past-blue rounded-xl">
                          <div class="text-sm text-gray-500">
                            <span class="font-semibold text-secondary">{{ reply.author.uuid === memberProfile.uuid ? 'Me' : reply.author.name }}</span>
                            {{ ' ' }}
                            <span class="">&middot;</span>
                            {{ ' ' }}
                            <span class="text-xs">{{ postedAt(reply.createdAt) }}</span>
                          </div>
                          <div class="py-1.5 text-black text-justify">
                            <p v-html="reply.message"></p>
                          </div>
                          <div class="flex items-center mt-2 space-x-2 text-xs">
                            <span v-if="reply.likes > 0"
                                  class="inline-flex items-center space-x-0.5 px-1.5 py-0.5 mb-1 rounded text-xs bg-secondary text-secondary-500-c opacity-70">
                              <ThumbUpIcon class="w-4 h-4"></ThumbUpIcon>
                              <!--                              <span class="text-xs">{{ Math.floor(Math.random() * (15 - 1)) + 1 }}</span>-->
                              <span class="text-xs">{{ reply.likes }}</span>
                            </span>
                            <button
                                v-if="reply.author.uuid !== memberProfile.uuid"
                                @click="likeComment($event, reply)"
                                type="button"
                                class="border-b-2 border-transparent hover:border-gray-400 hover:text-gray-900">
                              <span class="font-bold text-gray-600">Like</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>


            </li>
          </ul>
        </div>

      </div>
      <div class="px-4 py-6 border-t sm:px-6">
        <div class="flex space-x-3">
          <div class="flex-shrink-0">
            <span class="inline-block overflow-hidden w-10 h-10 bg-gray-200 rounded-full shadow">
              <svg class="w-full h-full text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
              </svg>
            </span>
          </div>
          <div class="flex-1 min-w-0">
            <!--            <div class="border-b-2 border-gray-400 focus-within:border-primary-500">-->
            <div class="">
              <label for="comment-editor" class="sr-only" v-if="replyToPostObject === null">comment</label>
              <label for="comment-editor" class="block mb-4 text-sm text-gray-700" v-else>Reply to <span
                  class="font-semibold">{{ replyToPostObject.author.name }}</span></label>
              <textarea v-model.trim="wrotePost"
                        ref="comment-editor"
                        id="comment-editor"
                        name="comment-editor"
                        rows="3"
                        class="block w-full rounded-md border border-gray-300 shadow-sm focus:border-primary focus:ring-0 focus:outline-none sm:text-sm"
                        placeholder="Write your comment..."/>
              <!--              class="block p-0 pb-2 w-full bg-transparent border-0 border-b border-transparent resize-none focus:ring-0 focus:border-primary-500 sm:text-sm"-->
            </div>
            <div class="flex justify-end items-center mt-3">
              <!--                <a href="#" class="inline-flex items-start space-x-2 text-sm text-gray-500 group hover:text-gray-900">-->
              <!--                  <QuestionMarkCircleIcon class="flex-shrink-0 w-5 h-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />-->
              <!--                  <span>Some HTML is okay.</span>-->
              <!--                </a>-->
              <button
                  @click.stop="sendPost($event)"
                  type="submit"
                  id="submit-post-button"
                  ref="submit-post-button"
                  :disabled="wrotePost === null || wrotePost.length === 0"
                  :class="{ 'cursor-not-allowed' : (wrotePost === null || wrotePost.length === 0) }"
                  class="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white rounded-md border border-transparent shadow-sm bg-ternary hover:bg-ternary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ternary">
                Post comment
              </button>
              <div ref="comment-goto"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>²

<script>
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'

import {
  ArrowNarrowLeftIcon,
  HomeIcon,
  PaperClipIcon,
  QuestionMarkCircleIcon,
  ReplyIcon,
  SearchIcon,
  ThumbUpIcon
} from '@heroicons/vue/solid'

import {BellIcon, MenuIcon, XIcon,} from '@heroicons/vue/outline'
import _merge from 'lodash/merge'
import {mapGetters} from "vuex";

export default {
  name: "CompanyComments",
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverOverlay,
    PopoverPanel,
    TransitionChild,
    TransitionRoot,
    ArrowNarrowLeftIcon,
    BellIcon,
    HomeIcon,
    MenuIcon,
    PaperClipIcon,
    QuestionMarkCircleIcon,
    SearchIcon,
    XIcon,
    ReplyIcon,
    ThumbUpIcon,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    memberProfile: {
      type: Object,
      default() {
        return {
          "activeUpdatedAt": "2021-01-01T100:00:00+00:00",
          "createdAt": "2021-01-01T100:00:00+00:00",
          "initials": "JS",
          "fullName": "John Smith"
        }
      }
    }
  },
  created() {
    this.loadPosts()
    // this.$store.dispatch('loadCompanyPosts', {
    //   company: this.$props.company,
    //   channel: {uuid: this.getChannelUuid(this.currentViewChannel)},
    // }).then(function (posts) {
    //   if (posts.length > 0) {
    //     this.posts = posts;
    //     this.displayDefaultPost = false;
    //     this.$nextTick(() => {
    //       const el = this.$refs['comments-section'];
    //       el.scrollIntoView({behavior: 'auto', block: "end", inline: "end"});
    //     });
    //   }
    // }.bind(this));
  },
  data() {
    return {
      replyToPostObject: null,
      wrotePost: null,
      posts: [{
        "uuid": this.uuidv4(),
        "post": {
          "uuid": this.uuidv4(),
          "author": {
            "uuid": this.uuidv4(),
            "username": "bot@sineora.com",
            "name": "Sineora Bot",
            "createdAt": (new Date()).toUTCString(),
            "updatedAt": (new Date()).toUTCString(),
          },
          "repliedTo": null,
          "replies": [],
          "rawMessage": "Hi <strong>"+this.$props.memberProfile.fullName+"</strong>, <br style='margin-bottom: 0.5rem;'>you can use this free comments area to share your opinion about this company.",
          "message": "Hi <strong>"+this.$props.memberProfile.fullName+"</strong>, <br style='margin-bottom: 0.5rem;'>you can use this free comments area to share your opinion about this company.",
          "media": null,
          "state": 1,
          "spamCount": 0,
          "inappropriateCount": 0,
          "createdAt": (new Date()).toUTCString(),
          "updatedAt": (new Date()).toUTCString(),
          "likes": 0,
          "dislikes": 0,
          "textState": "approved"
        },
        "createdAt": (new Date()).toUTCString(),
        "updatedAt": (new Date()).toUTCString(),
      }],
      displayDefaultPost: true,
    }
  },
  methods: {
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    postedAt(date) {
      const now = new Date();
      date = new Date(date);
      if (now.getTime() - date.getTime() > 86400000) { // > 24 hours
        return date.toLocaleString('en-US', {dateStyle: 'short', timeStyle: 'short'});
      }
      return date.toLocaleString('en-US', {timeStyle: 'short'});
    },
    stringToColour(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      hash = 100 * hash;

      let colour = '#';
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
      }
      return colour;
    },

    replyTo($event, post) {
      this.replyToPostObject = post;

      const el = this.$refs['comments-section'];
      // const el = this.$refs['submit-post-button'];
      const ed = this.$refs['comment-editor'];

      if (el) {
        ed.focus();
        el.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
      }
    },

    sendPost($event) {
      this.$store.dispatch('createCompanyPost', {
        channel: {uuid: this.getChannelUuid(this.currentViewChannel)},
        company: this.$props.company,
        content: this.wrotePost,
        replyTo: this.replyToPostObject !== null ? this.replyToPostObject.referrerObjectIdentifier : null,
      }).then(function (companyPost) {
        if (null !== this.replyToPostObject) {
          if (this.replyToPostObject.replies === undefined) {
            this.replyToPostObject.replies = [];
          }

          this.replyToPostObject.replies.push(companyPost.post);

          let replyToPostObject = this.replyToPostObject;
          this.$nextTick(() => {
            const el = this.$refs['post-' + replyToPostObject.referrerObjectIdentifier];
            el[0].scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
          });

        } else {
          if(this.displayDefaultPost) {
            this.posts = [];
            this.displayDefaultPost = false;
          }
          this.posts.push(companyPost);
        }

        this.wrotePost = null;
        this.replyToPostObject = null;
      }.bind(this))
    },

    fakerSendPost($event) {
      let postObject = {
        id: Math.floor(Math.random() * (30000 - 8)) + 8,
        name: 'Me',
        datetime: new Date(),
        body: this.wrotePost,
      };

      if (null !== this.replyToPostObject) {
        if (this.replyToPostObject.replies === undefined) {
          this.replyToPostObject.replies = [];
        }

        this.replyToPostObject.replies.push(postObject);

        let replyToPostObject = this.replyToPostObject;
        this.$nextTick(() => {
          const el = this.$refs['post-' + replyToPostObject.id];
          el[0].scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
        });

      } else {
        this.posts.push(postObject);
      }

      this.wrotePost = null;
      this.replyToPostObject = null;
    },
    likeComment($event, comment) {
      comment.likes++;
      this.$store.dispatch('createCompanyPostVote', {
        companyPost: {
          uuid: comment.referrerObjectIdentifier,
        },
        voteValue: 1,
      })
          .then(function (updatedComment) {
            _merge(comment, updatedComment.post);
          }.bind(this))
          .catch(function (error) {
            comment.likes--;
          }.bind(this));
    },

    async loadPosts() {
      const channelUuid = this.getChannelUuid(this.currentViewChannel);
      let posts = [];

      if(null === channelUuid) {
        posts = await this.$store.dispatch('loadCompanyPosts', {
          company: this.$props.company,
          channel: null,
        });
      } else {
        const [globalPosts, channelPosts] = await Promise.all([
          this.$store.dispatch('loadCompanyPosts', {
            company: this.$props.company,
            channel: null,
          }),
          this.$store.dispatch('loadCompanyPosts', {
            company: this.$props.company,
            channel: {uuid: channelUuid},
          })
        ]);

        posts = globalPosts.concat(channelPosts).sort((p1, p2) => p1.order > p2.order)
      }

      if (posts.length > 0) {
        this.posts = posts;
        this.displayDefaultPost = false;
        this.$nextTick(() => {
          const el = this.$refs['comments-section'];
          el.scrollIntoView({behavior: 'auto', block: "end", inline: "end"});
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      currentViewChannel: "getCurrentViewChannel",
      getChannelUuid: 'getChannelUuid',
    }),
  }
}
</script>